import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type EnvironmentSettings, type LinkItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.Risicoscan, {
  isVisible: (settings: EnvironmentSettings) =>
    settings.isActiveAdviseur || settings.isInterneGebruiker || settings.isMaatschappij,
  create: (): LinkItem => ({
    itemtype: 'link',
    menuItem: MenuItems.Risicoscan,
    title: 'Risicoscan',
    url: '/net/riskinventarisation/',
    iconclass: 'fas fa-wrench',
  }),
});
